//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import pagedown from 'pagedown';
export default {
  name: 'Details',
  props: {
    /**
     * Product Details long description
     */
    description: {
      type: String,
      default: ''
    },
    /**
     * Product Details long description (legacy data)
     */
    legacyDescription: {
      type: String,
      default: ''
    },
    /**
     * Product Details importer
     */
    importer: {
      type: String,
      default: ''
    },
    /**
     * Items included with the product ([String])
     */
    includedItems: {
      type: Array,
      default: () => []
    },
    /**
     * Product highlights ([{ iconUrl, label }])
     */
    highlights: {
      type: Array,
      default: () => []
    },
    /**
     * Product Details origin country
     */
    originCountry: {
      type: String,
      default: ''
    },
    /**
     * Product Details warnings
     */
    warnings: {
      type: String,
      default: ''
    },
    /**
     * If bundle, pass in currently selected bundle products
     */
    selectedBundleVariants: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    showLegacyDescription() {
      return !!this.legacyDescription && this.legacyDescription.length > 0;
    }
  },
  methods: {
    convertMarkdown(paragraph) {
      if (paragraph) {
        const safeConverter = pagedown.getSanitizingConverter();
        return safeConverter.makeHtml(paragraph);
      }
      return '';
    }
  }
};
